import { getLocationPointCityId } from '@commons/models/LocationPoint';
import getLocationPointArea from '@commons/models/LocationPoint/getters/getArea';
import setLocationPointArea from '@commons/models/LocationPoint/setters/setArea';
import getSearchedLocation from '@location/selectors/getSearchedLocation';
import dispatchSearchedLocation from '@location/actions/dispatchSearchedLocation';
import fetchAreaById from '@core/reducers/areas/actions/fetchAreaById';

const setAreaToSearchedLocation = areaId => async (dispatch, getState) => {
  const searchedLocation = getSearchedLocation(getState());
  if (areaId && searchedLocation && !getLocationPointArea(searchedLocation)) {
    const cityId = getLocationPointCityId(searchedLocation);
    if (cityId) {
      const area = await dispatch(fetchAreaById({ areaId }));
      if (area) {
        const location = setLocationPointArea(searchedLocation, area);
        dispatch(dispatchSearchedLocation(location));
      }
    }
  }
};

export default setAreaToSearchedLocation;
